import { useState } from "react";
import { CustomMetadata, QueryOperator } from "types";
import { useCustomMetadataModal } from "hooks/useCustomMetadataModal";
import QueryModalInput from "views/components/QueryModal/QueryModalInput";
import { CustomNameStringIcon } from "assets/icons/CustomMetadataIcons";
import BaseQueryModal from "./BaseQueryModal";
import { useTextQueryModal } from "hooks/UseQueryModal/useTextQueryModal";

interface StringModalProps {
  field: CustomMetadata;
  editQueryId?: string;
}

export default function StringModal({ editQueryId, field }: StringModalProps) {
  const { modalRef, oldQuery, handleSubmission, fieldName } =
    useCustomMetadataModal({ field, editQueryId });

  const previousValue = (oldQuery?.custom_metadata?.value as string) || "";
  const [searchText, setSearchText] = useState(previousValue);

  const { isSubmitDisabled } = useTextQueryModal({
    inputValue: searchText,
    previousValue,
    editQueryId,
  });

  const handleSubmit = () => {
    if (isSubmitDisabled) return;
    handleSubmission(QueryOperator.CONTAINS, searchText.trim());
  };

  const handleInputChange = (value: string) => {
    setSearchText(value);
  };

  return (
    <BaseQueryModal
      title={fieldName}
      modalRef={modalRef}
      icon={<CustomNameStringIcon />}
      isSubmitDisabled={isSubmitDisabled}
      onSubmit={handleSubmit}
    >
      <QueryModalInput
        searchText={searchText}
        onInputChange={handleInputChange}
      />
    </BaseQueryModal>
  );
}
